@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.auto-batch-modal-body {
  padding: 24px 16px;
  min-height: 360px;
}

.part-bold {
  font-weight: 500;
}

.part-bolder {
  font-weight: 600;
}

.param-input,
.radio-input {
  margin: 10px 0;
  font-size: 13px;
}

.param-input {
  > div {
    padding-top: 4px;
  }

  textarea {
    width: 100%;
  }

  .label {
    font-weight: 500;
  }
}

.radio-input {
  display: flex;
  align-items: baseline;
  .has-error {
    border-color: @auto-batch--input-components--error--border-color;
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  &.initial {
    display: initial;
  }
}

.auto-batch-error {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 10px;
  width: 100%;
}

.banner-child-wrapper {
  > div {
    width: 100%;
  }
}

.loading-icon {
  height: 82px;
  margin: 110px 0;
}

.confirm-move-actions {
  display: flex;
  margin-top: 8px;
}

.exclude-button {
  margin-left: 8px;
}

.auto-batch-radio {
  width: 155px;
}

.auto-batch-input {
  width: 100px;
}

.number-and-tip {
  display: flex;
  align-items: center;
}

.helper-tip {
  margin-left: 10px;
  max-width: 350px;
  .helper-bold {
    font-weight: 500;
  }
}

.inline-limit-width {
  max-width: 350px;
}

.results-block {
  width: 300px;
  margin-bottom: 25px;
  border: 1px solid @auto-batch--results--table-border-color;
  border-radius: 4px;
}

.results-header,
.results-row {
  display: grid;
  grid-template-columns: 140px auto;
  padding: 12px;
}

.results-header {
  font-weight: 500;
  border-bottom: 2px solid @auto-batch--results--table-border-color;
}

.results-row {
  border-bottom: 1px solid @auto-batch--results--table-border-color;
}
